import baseConfiguratorReducer from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer';
import { resolveLineFontSizeForFont } from './fontData';
import { actionTypes } from './Actions';
import { isVerticalTextAvailable } from './Selectors';

export default function configuratorReducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_DISPLAY_NET_PRICES: {
      const value = (action as { value: boolean }).value;
      return {
        ...state,
        displayNetPrices: value,
      };
    }
    case actionTypes.SET_IS_ON_DEMAND_PRICE: {
      console.error('SET_IS_ON_DEMAND_PRICE', action.value);
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration?.customdata,
            isOnDemandPrice: action.value,
          },
        },
      };
    }
    case actionTypes.SET_WEHA_LINES: {
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration?.customdata,
            wehaLines: action.lines,
          },
        },
      };
    }
    case actionTypes.SET_WEHA_GLOBAL_SETTINGS: {
      const prevGlobalSettings = state.configuration?.customdata?.wehaGlobalSettings;
      const nextGlobalSettings = {
        ...prevGlobalSettings,
        ...action.globalSettings,
      };
      const lines = state.configuration?.customdata?.wehaLines;
      const fontData = state.configuration?.customdata?.wehaFontData ?? [];
      const shouldNormalizeFontSizes =
        action.globalSettings?.fontFamily != null &&
        action.globalSettings.fontFamily !== prevGlobalSettings?.fontFamily;
      const verticalMustReset = !isVerticalTextAvailable(nextGlobalSettings) && Array.isArray(lines);

      let nextLines = lines;
      if (Array.isArray(lines) && (shouldNormalizeFontSizes || verticalMustReset)) {
        const fontId = nextGlobalSettings.fontFamily ?? '';
        nextLines = lines.map((line) => {
          const withVertical = verticalMustReset ? { ...line, vertical: false } : { ...line };
          if (!shouldNormalizeFontSizes) return withVertical;
          return {
            ...withVertical,
            fontSize: resolveLineFontSizeForFont(withVertical, fontData, fontId),
          };
        });
      }
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration?.customdata,
            wehaGlobalSettings: nextGlobalSettings,
            ...(nextLines !== lines ? { wehaLines: nextLines } : {}),
          },
        },
      };
    }
    case actionTypes.SET_WEHA_SELECTED_LINE_ID: {
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration?.customdata,
            wehaSelectedLineId: action.selectedLineId,
            wehaSelectedLineIds: action.selectedLineId ? [action.selectedLineId] : [],
          },
        },
      };
    }
    case actionTypes.SET_WEHA_SELECTED_LINE_IDS: {
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration?.customdata,
            wehaSelectedLineIds: action.selectedLineIds,
            wehaSelectedLineId: action.selectedLineIds[0] ?? null,
          },
        },
      };
    }
    case actionTypes.SET_WEHA_CANVAS_DATA: {
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration?.customdata,
            wehaCanvasData: action.canvasData,
          },
        },
      };
    }
    case actionTypes.RECEIVE_WEHA_FONT_DATA: {
      const data = Array.isArray(action.data) ? action.data : [];
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration?.customdata,
            wehaFontData: data,
          },
        },
      };
    }
    case actionTypes.RECEIVE_ADD_TO_CART: {
      return {
        ...state,
        showOrderSuccess: true,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration?.customdata,
            erpOrderId: action.data.exportStatus.erpOrderId,
          },
        },
      };
    }
    default: {
      return baseConfiguratorReducer(state, action);
    }
  }
}
